var map = {
	"./Github.webp": 8232,
	"./apple.png": 4719,
	"./apple2.png": 678,
	"./bio.png": 1955,
	"./directory.png": 2000,
	"./folder.png": 8081,
	"./image.png": 2232,
	"./mail.png": 3008,
	"./noss.webp": 8895,
	"./opensource.png": 368,
	"./photos.png": 6551,
	"./resume.png": 6331,
	"./video.png": 3392,
	"./webos.png": 3669
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7855;